import * as v from 'valibot';
import { SequencingModelSchema } from './sequencingModelSchema';

export const SequenceTypeSchema = v.object({
  summaryTable: v.array(v.string()),
  productCards: v.array(v.string()),
  sourceModel: SequencingModelSchema,
});
